export default __webpack_public_path__ + "static/media/nv.e1eb863c.png";